import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Axios, { authHeaders } from "../../helpers/axios";
import { apiEndpoints } from "../../helpers/constants";
import { notify, notifyAPIMessages } from "../../helpers/commonFunction";
import { reqToForceUserLogout } from "./userSlice";

const initialState = {
  error: "",
  loader: false,
  teamList: [],
  territoryList: [],
  districtList: [],
};

const creationSlice = createSlice({
  name: "creation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {},
});

export default creationSlice.reducer;
